module.exports = __webpack_public_path__ + "img/hzico_8.c39fb6f0.jpg";